import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Div } from "components/Base";
import { actions, getters } from "../model";
import Tabs from "./Tabs";
import { TAB_IDS } from "../constants";
import Details from "./Details";
import { getBackgroundColor } from "Portal/NewPortal/PortalHome/selectors";
import Messages from "./Messages";

const decorate = connect(
  state => ({
    loading: getters.loading(state),
    selectedTab: getters.selectedTab(state),
    backgroundColor: getBackgroundColor(state)
  }),
  {
    init: actions.init
  }
);

const Body = ({
  selectedTab = TAB_IDS.DETAILS,
  backgroundColor = null,
  loading = true
}) => {
  const Content = R.prop(selectedTab)({
    [TAB_IDS.DETAILS]: Details,
    [TAB_IDS.MESSAGES]: Messages
  });

  return (
    <Div
      display="column"
      width={1}
      height={1}
      style={{
        padding: "3px 20px 20px 20px",
        gap: "16px",
        ...(backgroundColor ? { backgroundColor } : {})
      }}
    >
      {!loading && <Tabs />}
      <Content />
    </Div>
  );
};

export default decorate(Body);
